namespace TabAurous.Stock {
    export interface StockItemBOMRow {
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        ProductTypeName?: string;
        ItemType?: string;
        ItemTypeId?: number;
        StoneColorId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        ProductCode?: string;
        ProductName?: string;
        IsCustomerItem?: boolean;
        PointerWeight?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        Attribute?: string;
        SieveId?: number;
        GroupSieveId?: number;
        StockBomId?: number;
        StockId?: number;
        ProductId?: number;
        Line_No?: number;
        SettingId?: number;
        StoneStatusId?: number;
        CertificateNo?: string;
        Lab?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        CalcOn?: string;
        BomRate?: number;
        BomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        CategoryName?: string;
        SubCategoryName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        ShapeCode?: string;
        MetalColorName?: string;
        KaratName?: string;
        StoneSizeName?: string;
        SieveName?: string;
        GroupSieveName?: string;
        Parts?: number;
        TextureId?: number;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
    }

    export namespace StockItemBOMRow {
        export const idProperty = 'StockBomId';
        export const nameProperty = 'CertificateNo';
        export const localTextPrefix = 'Stock.StockItemBOM';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            ProductTypeName = "ProductTypeName",
            ItemType = "ItemType",
            ItemTypeId = "ItemTypeId",
            StoneColorId = "StoneColorId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            IsCustomerItem = "IsCustomerItem",
            PointerWeight = "PointerWeight",
            BOMProductId = "BOMProductId",
            BOMAttributeId = "BOMAttributeId",
            Attribute = "Attribute",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            StockBomId = "StockBomId",
            StockId = "StockId",
            ProductId = "ProductId",
            Line_No = "Line_No",
            SettingId = "SettingId",
            StoneStatusId = "StoneStatusId",
            CertificateNo = "CertificateNo",
            Lab = "Lab",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            CalcOn = "CalcOn",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            Remarks = "Remarks",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            ShapeCode = "ShapeCode",
            MetalColorName = "MetalColorName",
            KaratName = "KaratName",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            GroupSieveName = "GroupSieveName",
            Parts = "Parts",
            TextureId = "TextureId",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId"
        }
    }
}
